module.exports = __webpack_public_path__ + "static/img/one.bcfa4a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smallFishImg/one.png
// module id = ilcD
// module chunks = 1